import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import { fCurrencyRupees } from 'src/utils/format-number';

import Scrollbar from 'src/components/scrollbar';

export interface IStationerySummaryLineItem {
  key: string;
  itemName: string;
  itemCode?: string;
  quantity: number;
  unitPrice: number;
  discount: number;
  totalAfterDiscount: number;
}

type Props = {
  items: IStationerySummaryLineItem[];
};

export default function StationeryPurchaseOrderItemsSummary({ items }: Props) {
  return (
    <Card sx={{ p: 2, position: { lg: 'sticky' }, top: { lg: 24 } }}>
      <Typography variant="subtitle1" sx={{ px: 1, pb: 1 }}>
        Items · {items.length}
      </Typography>

      {items.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ px: 1, py: 2 }}>
          No items added yet
        </Typography>
      ) : (
        <Scrollbar sx={{ maxHeight: 560 }}>
          <Stack spacing={1.5} sx={{ p: 1 }}>
            {items.map((item) => (
              <Stack
                key={item.key}
                spacing={0.75}
                sx={{ p: 1.5, borderRadius: 1, bgcolor: 'background.neutral' }}
              >
                <Typography variant="subtitle2" noWrap sx={{ minWidth: 0 }}>
                  {item.itemName || 'Select item'}
                </Typography>

                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="caption" color="text.secondary">
                    Qty: {item.quantity}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Unit Cost: {fCurrencyRupees(item.unitPrice * 100)}
                  </Typography>
                </Stack>

                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="caption" color="text.secondary">
                    Discount: {fCurrencyRupees(item.discount * 100)}
                  </Typography>
                </Stack>

                <Divider sx={{ borderStyle: 'dashed' }} />

                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="subtitle2">Total</Typography>
                  <Typography variant="subtitle2">
                    {fCurrencyRupees(item.totalAfterDiscount * 100)}
                  </Typography>
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Scrollbar>
      )}
    </Card>
  );
}
